module.exports = __webpack_public_path__ + "static/images/vehicle.13VqUQT.png";